import Vue from 'vue'
import VueRouter from 'vue-router'
import ConceptDetail from '../views/ConceptDetail'

Vue.use(VueRouter)

const routes = [
  {
    path: '/explorer-les-concepts/:terminologyId',
    name: 'ConceptDetail',
    component: ConceptDetail
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router